import { computed } from 'vue';
import { usePage } from '@inertiajs/vue3';

export default function useBackendRouting() {
  const locale = computed(() => usePage().props.appLocale);

  /**
   * Expose the route method from the window object.
   *
   * @param {string} name
   * @param {object} parameters
   */
  function route(name: string, parameters: any = {}) {
    name = locale.value + '.' + name;

    return unlocalizedRoute(name, parameters);
  }

  /**
   * Expose the unlocalized route method from the window object.
   *
   * @param {string} name
   * @param {object} parameters
   */
  function unlocalizedRoute(name: string, parameters: any = {}) {
    return (window as any).route(name, parameters);
  }

  /**
   * Expose the unlocalized route method from the window object.
   *
   * @param {string} name
   * @param {object} parameters
   */
  function apiRoute(name: string, parameters: any = {}) {
    return (window as any).route(name, parameters);
  }

  /**
   * Returns the intended URL from the backend, if available.
   */
  function intendedUrl(): string | null {
    return usePage().props.intendedUrl ?? null;
  }

  return {
    route,
    unlocalizedRoute,
    apiRoute,
    intendedUrl,
  };
}
